import React from 'react';
import { useTranslation } from 'react-i18next';

export const useAccountDetailsFields = (): {
    key: string;
    label: string;
}[] => {
    const { t } = useTranslation();

    return React.useMemo(
        () => [
            {
                key: 'firstName',
                label: t('backgroundCheck.labels.firstName'),
            },
            {
                key: 'lastName',
                label: t('backgroundCheck.labels.lastName'),
            },
            {
                key: 'ssn',
                label: t('backgroundCheck.labels.ssn'),
            },
            {
                key: 'dateOfBirth',
                label: t('backgroundCheck.labels.dateOfBirth'),
            },
            {
                key: 'email',
                label: t('backgroundCheck.labels.email'),
            },
            {
                key: 'stateOfWork',
                label: t('backgroundCheck.labels.workState'),
            },
            {
                key: 'address.addressLine1',
                label: t('backgroundCheck.labels.addressLine1'),
            },
            {
                key: 'address.city',
                label: t('backgroundCheck.labels.city'),
            },
            {
                key: 'address.state',
                label: t('backgroundCheck.labels.state'),
            },
            {
                key: 'address.postalCode',
                label: t('backgroundCheck.labels.zip'),
            },
        ],
        [t],
    );
};
